// src/routes/PrivacyPolicy.jsx
import ContentPage from "@/components/content/ContentPage";

const PrivacyPolicy = () => <ContentPage docKey="privacy" placeholder />;

export default PrivacyPolicy;
